import { AfterViewInit, Component } from "@angular/core";
import { Router } from "@angular/router";
import { FilterService } from "app/bundles/requests/shared/services/filter.service";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { StorageService } from "app/shared/services/storage.service";
import { RequestApi } from "../shared/api-services/request-api/request-api.models";

@Component({
  selector: "app-request-download",
  templateUrl: "./request-download.component.html",
  styleUrls: ["./request-download.component.scss"],
})
export class RequestDownloadComponent implements AfterViewInit {
  private errorMessage: string;

  constructor(
    private router: Router,
    private requestApiService: RequestApi,
    private storageService: StorageService,
    private filterService: FilterService,
    private utilService: UtilService,
  ) {}

  ngAfterViewInit(): void {
    void this.router.navigate(["/list"]);
  }
}
